import {
  GET_ASSET_WORKSPACE,
  CREATE_ASSET_IMPORT_SOURCE,
  CREATE_ASSET_IMPORT_TOKEN,
  GET_ASSET_SCHEMAS,
  SET_SELECTED_ASSET_SCHEMA,
  SET_IMPORT_SOURCE_NAME,
  SET_OBJECT_TYPE_NAME,
  CLEAR_ASSET,
} from "./types";
import { callWithBasicAuth } from "../../common/modules/http.bridge.client";
import { getBridgeJiraAPIBaseURL, getBridgeJiraBaseURL } from "../../env/stage";
import { BasicCredentials } from "../../common/interfaces/credentials/Credentials";

const WORKSPACE_URL =
  getBridgeJiraBaseURL() + "/rest/servicedeskapi/assets/workspace";
const IMPORT_SOURCE_URL =
  getBridgeJiraBaseURL() + "/gateway/api/jsm/assets/workspace";
const ASSET_SCHEMAS = "/v1/objectschema/list";
const ATLASSIAN_API = getBridgeJiraAPIBaseURL() + "/jsm/insight/workspace/";

export const getAssetWorkspace =
  (credentials: BasicCredentials) => (dispatch: any) => {
    callWithBasicAuth(WORKSPACE_URL, "GET", credentials, {})
      .then((res) => {
        dispatch({
          type: GET_ASSET_WORKSPACE,
          payload: getWorkspaceId(getResponseBody(res)),
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };
const getWorkspaceId = (workspaceResponse: any) => {
  if (!workspaceResponse) {
    return "";
  } else if (workspaceResponse.values && workspaceResponse.values.length > 0) {
    return workspaceResponse.values[0].workspaceId;
  }
  return "";
};

export const createImportSource =
  (
    workspace: string,
    objectSchemaId: string,
    importSourceName: string,
    credentials: BasicCredentials
  ) =>
  (dispatch: any) => {
    const data = {
      objectSchemaId: objectSchemaId,
      defaultConcatenator: "-",
      defaultHandleEmptyValues: "IGNORE",
      defaultHandleUnknownValues: "ADD",
      dateFormat: "",
      dateTimeFormat: "",
      importSpecificConfiguration:
        '{"fileId":"","defaultDelimiter":",","defaultEncoding":"UTF-8"}',
      importSourceModuleKey: "rlabs-import-type-external",
      name: importSourceName,
      importStatus: {},
      id: null,
      importSourceUrlTokenChanged: false,
    };
    callWithBasicAuth(
      IMPORT_SOURCE_URL + "/" + workspace + "/v1/importsource",
      "POST",
      credentials,
      data
    ).then((res) => {
      dispatch({
        type: CREATE_ASSET_IMPORT_SOURCE,
        payload: getResponseBody(res),
      });
    });
  };

export const createImportToken =
  (workspace: string, importSourceId: string, credentials: BasicCredentials) =>
  (dispatch: any) => {
    const data = {};
    callWithBasicAuth(
      IMPORT_SOURCE_URL +
        "/" +
        workspace +
        "/v1/importsource/" +
        importSourceId +
        "/token",
      "POST",
      credentials,
      data
    ).then((res) => {
      dispatch({
        type: CREATE_ASSET_IMPORT_TOKEN,
        payload: getResponseBody(res)?.token,
      });
    });
  };

export const getAssetSchemas =
  (workspace: string, credentials: BasicCredentials) => (dispatch: any) => {
    callWithBasicAuth(
      ATLASSIAN_API + workspace + ASSET_SCHEMAS,
      "GET",
      credentials,
      {}
    ).then((res) => {
      dispatch({
        type: GET_ASSET_SCHEMAS,
        payload: getResponseBody(res),
      });
    });
  };
export const setSelectedAssetSchema = (assetSchema: any) => (dispatch: any) => {
  dispatch({
    type: SET_SELECTED_ASSET_SCHEMA,
    payload: assetSchema,
  });
};
export const setImportSourceName =
  (importSourceName: string) => (dispatch: any) => {
    dispatch({
      type: SET_IMPORT_SOURCE_NAME,
      payload: importSourceName,
    });
  };
export const clearToken = () => (dispatch: any) => {
  dispatch({
    type: CREATE_ASSET_IMPORT_TOKEN,
    payload: "",
  });
};
export const clearImportSource = () => (dispatch: any) => {
  dispatch({
    type: CREATE_ASSET_IMPORT_SOURCE,
    payload: "",
  });
};
export const setObjectTypeName =
  (objectTypeName: string) => (dispatch: any) => {
    dispatch({
      type: SET_OBJECT_TYPE_NAME,
      payload: objectTypeName,
    });
  };
const getResponseBody = (res: any) => {
  return res;
};
export const clearAsset = () => (dispatch: any) => {
  dispatch({
    type: CLEAR_ASSET,
    payload: {},
  });
};
